module.exports = __webpack_public_path__ + "static/media/speech_bubbles_v2.1463f1b7.webp";